module.exports = function (value, fallback) {
    return value || fallback || '';
};
